<template>
  <div>
    <v-dialog v-model="dialog" max-width="500" :persistent="loading">
      <v-card>
        <v-card-title>Vincular técnico</v-card-title>
        <v-card-text>
          <technician-selector
            v-model="technician"
            class="mt-2"
            :platforms="[party.Organization.Platform.id]"
            :filter-technicians="filterTechnicians"
          />
        </v-card-text>

        <v-card-actions>
          <v-btn text @click="close" :disabled="loading">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!technician"
            :loading="loading"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmModal ref="confirmModal" />
  </div>
</template>

<script>
import PARTY from "@/services/admin/parties";
import TechnicianSelector from "@/components/global/selector/TechnicianSelector.vue";

export default {
  props: {
    party: {
      type: Object,
      required: true,
    },
    technicians: {
      type: Array,
      required: true,
    },
  },
  components: {
    TechnicianSelector,
  },
  data() {
    return {
      dialog: false,
      isValid: false,
      loading: false,
      technician: null,
      error: null,
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.technician = null;
    },
    close() {
      this.dialog = false;
    },
    async save() {
      this.loading = true;
      this.error = null;
      try {
        await PARTY.addTechnician(this.party.id, {
          technicianId: this.technician.id,
        });
        this.$emit("success");
        this.close();
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    filterTechnicians(technician) {
      console.log(technician, this.technicians);
      const index = this.technicians.findIndex(
        (t) => t.userId === technician.id
      );
      return index === -1;
    },
  },
  computed: {},
  mounted() {
    this.$root.$on("add-party-technician", this.open);
  },
};
</script>
